const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "http://localhost:8000";

  const API_BASE =
  process.env.REACT_APP_API_BASE_URL || "http://localhost:8000";
  
const SESSION_KEY = "veya_session_id_v1";

function getSessionId() {
  let id = localStorage.getItem(SESSION_KEY);
  if (!id) {
    id = `${Date.now()}_${Math.random().toString(16).slice(2)}`;
    localStorage.setItem(SESSION_KEY, id);
  }
  return id;
}

async function postEvent(payload) {
  const token = localStorage.getItem("veya_token");

  const res = await fetch(`${API_BASE}/interaction-events`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Veya-Session-Id": getSessionId(),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    const text = await res.text().catch(() => "");
    throw new Error(
      `Failed to log interaction event (${res.status})${text ? `: ${text}` : ""}`
    );
  }

  return res.json();
}

export function logProductSaved({
  productId,
  editId = null,
  surface = null,
  category = null,
  variant = null,
}) {
  return postEvent({
    event_type: "product_saved",
    product_id: productId,
    edit_id: editId,
    surface,
    category,
    variant,
  }).catch((e) => {
    console.error("[interactionEventsApi] logProductSaved failed", e);
  });
}

export function logProductUnsaved({
  productId,
  editId = null,
  surface = null,
  category = null,
  variant = null,
}) {
  return postEvent({
    event_type: "product_unsaved",
    product_id: productId,
    edit_id: editId,
    surface,
    category,
    variant,
  }).catch((e) => {
    console.error("[interactionEventsApi] logProductUnsaved failed", e);
  });
}

export function logProductAddedToBag({
  productId,
  editId = null,
  surface = null,
  category = null,
  variant = null,
}) {
  return postEvent({
    event_type: "product_added_to_bag",
    product_id: productId,
    edit_id: editId,
    surface,
    category,
    variant,
  }).catch((e) => {
    console.error("[interactionEventsApi] logProductAddedToBag failed", e);
  });
}

export function logProductRemovedFromBag({
  productId,
  editId = null,
  surface = null,
  category = null,
  variant = null,
}) {
  return postEvent({
    event_type: "product_removed_from_bag",
    product_id: productId,
    edit_id: editId,
    surface,
    category,
    variant,
  }).catch((e) => {
    console.error("[interactionEventsApi] logProductRemovedFromBag failed", e);
  });
}

export function logTryOnStarted({
  productId,
  editId = null,
  surface = "fitting_room",
  category = null,
  variant = null,
}) {
  return postEvent({
    event_type: "try_on_started",
    product_id: productId,
    edit_id: editId,
    surface,
    category,
    variant,
  }).catch((e) => {
    console.error("[interactionEventsApi] logTryOnStarted failed", e);
  });
}

export function logPromptSubmitted({
  productId = null,
  editId = null,
  surface = null,
  queryText,
  category = null,
  variant = null,
}) {
  const text = String(queryText || "").trim();
  if (!text) return Promise.resolve();

  return postEvent({
    event_type: "prompt_submitted",
    product_id: productId,
    edit_id: editId,
    surface,
    query_text: text,
    category,
    variant,
  }).catch((e) => {
    console.error("[interactionEventsApi] logPromptSubmitted failed", e);
  });
}